module.exports = __webpack_public_path__ + "img/nitja-online-500px.9e841df0.svg";